import React from 'react';
import './Testimonials.css';

const Testimonials: React.FC = () => {
  return (
    <section className="testimonials">
      <h2>What Our Clients Say</h2>
      <div className="testimonials-container">
        <div className="testimonial-card">
          <p>
            "RCOVR has been a total game-changer for my clinic. 
            Clients who used to struggle are now genuinely excited to show up."
          </p>
          <hr className="testimonial-divider" />
         
          <div className="testimonial-footer">
            <span className="testimonial-author">-Dr. Sarah Hashem</span>
            <div className="testimonial-stars">★★★★★</div>
          </div>
        </div>

        <div className="testimonial-card">
          <p>
           "RCOVR offers a diverse of immersive environments, providing our clients with
            a wide range of safe, controlled experiences."
          </p>
          <hr className="testimonial-divider" />
          
          <div className="testimonial-footer">
            <span className="testimonial-author">-Dr. sally Mortada</span>
            <div className="testimonial-stars">★★★★★</div>
          </div>
        </div>

        <div className="testimonial-card">
          <p>
           "RCOVR provides a level of immersion I haven't
            seen elsewhere where we can monitor closely our clients."
           
          </p>
          <hr className="testimonial-divider" />
          
          <div className="testimonial-footer">
            <span className="testimonial-author">-Dr. Jad Ibrahim</span>
            <div className="testimonial-stars">★★★★★</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
